import { render, staticRenderFns } from "./IconCheckSolid.vue?vue&type=template&id=4a532913"
import script from "./IconCheckSolid.vue?vue&type=script&lang=js"
export * from "./IconCheckSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports